import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRef, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import TriggleIcon from './TriggleIcon';
import AnimatedSection from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/AnimatedSection';
import CommonTitle from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/CommonTitle';
import Tabs from '../Tabs';

const Output: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Output');
    const swiperRef = useRef<any>(null);

    const [activeIndex, setActiveIndex] = useState(0);
    let tabs =
        locale === 'de'
            ? [
                  {
                      tabLabel: t('tab3'),
                      tabValue: 'a3',
                      pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761118310663-nr0s7v-compressed-RV%20Camping.jpg',
                      h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761118406909-qlq3lg-compressed-Wohnmobil/Camping.jpg',
                      things: [t('tab3_thing1'), t('tab3_thing2'), t('tab3_thing3'), t('tab3_thing4'), t('tab3_thing5')],
                      title: t('tab3_title'),
                      desc: t('tab3_desc'),
                  },
                  {
                      tabLabel: t('tab5'),
                      tabValue: 'b1',
                      pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761118342913-99n403-compressed-Garage.jpg',
                      h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761118432322-xfvnl1-compressed-Garage.jpg',
                      desc: t('tab5_desc'),
                      title: t('tab5_title'),
                      things: [t('tab5_thing1'), t('tab5_thing2'), t('tab5_thing3')],
                  },
                  {
                      tabLabel: t('tab6'),
                      tabValue: 'b2',
                      pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761118353944-poqaeq-compressed-Kitchen.jpg',
                      h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761118444763-4m8hbi-compressed-Waschraum.jpg',
                      things: [t('tab6_thing1'), t('tab6_thing2'), t('tab6_thing3'), t('tab6_thing4')],
                      desc: t('tab6_desc'),
                      title: t('tab6_title'),
                  },
                  {
                      tabLabel: t('tab1'),
                      tabValue: 'a1',
                      pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761118273464-wgyt40-compressed-Kitchen.jpg',
                      h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761118381931-sccsbg-compressed-Kitchen.jpg',
                      things: [t('tab1_thing1'), t('tab1_thing2'), t('tab1_thing3'), t('tab1_thing4'), t('tab1_thing5')],
                  },
              ]
            : [
                  {
                      tabLabel: t('tab1'),
                      tabValue: 'a1',
                      pc:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334431329/4-pc-1.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118273464-wgyt40-compressed-Kitchen.jpg',
                      h5:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334483552/4-h5-1.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118381931-sccsbg-compressed-Kitchen.jpg',
                      things: [t('tab1_thing1'), t('tab1_thing2'), t('tab1_thing3'), t('tab1_thing4'), t('tab1_thing5')],
                  },
                  {
                      tabLabel: t('tab2'),
                      tabValue: 'a2',
                      pc:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334431160/4-pc-2.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118292715-648o2o-compressed-Kitchen.jpg',
                      h5:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334484452/4-h5-2.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118394915-4d1y5p-compressed-Wohnzimmer.jpg',
                      things: [t('tab2_thing1'), t('tab2_thing2'), t('tab2_thing3'), t('tab2_thing4')],
                  },
                  {
                      tabLabel: t('tab3'),
                      tabValue: 'a3',
                      pc:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334431767/4-pc-3.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118310663-nr0s7v-compressed-RV%20Camping.jpg',
                      h5:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334484671/4-h5-3.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118406909-qlq3lg-compressed-Wohnmobil/Camping.jpg',
                      things: [t('tab3_thing1'), t('tab3_thing2'), t('tab3_thing3'), t('tab3_thing4'), t('tab3_thing5')],
                      title: t('tab3_title'),
                      desc: t('tab3_desc'),
                  },
                  {
                      tabLabel: t('tab4'),
                      tabValue: 'a4',
                      pc:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334431510/4-pc-4.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118331007-w993q4-compressed-Kitchen.jpg',
                      h5:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334484021/4-h5-4.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761704666185-hhlq1h-compressed-B%C3%BCro.jpg',
                      things: [t('tab4_thing1'), t('tab4_thing2'), t('tab4_thing3'), t('tab4_thing4')],
                      desc: t('tab4_desc'),
                      title: t('tab4_title'),
                  },
                  {
                      tabLabel: t('tab5'),
                      tabValue: 'b1',
                      pc:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334432323/4-pc-5.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118342913-99n403-compressed-Garage.jpg',
                      h5:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334484142/4-h5-5.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118432322-xfvnl1-compressed-Garage.jpg',
                      desc: t('tab5_desc'),
                      title: t('tab5_title'),
                      things: [t('tab5_thing1'), t('tab5_thing2'), t('tab5_thing3')],
                  },
                  {
                      tabLabel: t('tab6'),
                      tabValue: 'b2',
                      pc:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334432006/4-pc-6.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118353944-poqaeq-compressed-Kitchen.jpg',
                      h5:
                          locale === 'uk'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1765334483752/4-h5-6.jpg'
                              : 'https://websiteoss.ecoflow.com/figma-uploads/1761118444763-4m8hbi-compressed-Waschraum.jpg',
                      things: [t('tab6_thing1'), t('tab6_thing2'), t('tab6_thing3'), t('tab6_thing4')],
                      desc: t('tab6_desc'),
                      title: t('tab6_title'),
                  },
              ];

    const onChange = (item: any, index: number) => {
        setActiveIndex(index);
        swiperRef.current.slideTo(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);

        // tab 滚动
        const targetTabItem = document.querySelectorAll('.output-tabs .eco-tab-item')[index];
        const tabsEle = document.querySelector('.output-tabs .eco-tab-items-move');

        if (!targetTabItem || !tabsEle) return;
        const targetTabItemRect = targetTabItem.getBoundingClientRect();

        const tabsEleRect = tabsEle.getBoundingClientRect();

        tabsEle.scrollBy({
            left: targetTabItemRect.left - tabsEleRect.left - tabsEleRect.width / 2 + targetTabItemRect.width / 2,
            behavior: 'smooth',
        });
    };

    return (
        <div className={styles.Output + ' GtmModuleData-section'} id="Output" data-section-id="d3m-output">
            <EcoSpace hPc="160px" hPad="100px" hH5="60px" />
            <CommonTitle title={t('title')} desc={locale === 'de' ? '' : t('desc')} />

            <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <div className="swiper-output d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={1}
                        spaceBetween={12}
                        initialSlide={0}
                        onSlideChange={handleSlideChange}
                    >
                        {tabs.map((item, index) => (
                            <SwiperSlide key={index} className={`list-item list-item-${index + 1}`}>
                                <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} isOpenLazy={true} />
                                <div className="things">
                                    {item.things.map((thing, _index) => (
                                        <div key={_index} className={`thing thing-${index + 1}_${_index + 1}`}>
                                            {thing}

                                            <TriggleIcon className="triggle-icon" />
                                        </div>
                                    ))}

                                    {item.desc && (
                                        <div className="desc-wrapper">
                                            {item.title && <div className="title">{item.title}</div>}
                                            {item.desc && <div className="desc">{item.desc}</div>}
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                        {/* <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} /> */}
                    </Swiper>
                </div>
                {/* <EcoTab className="d3m-tabs d3m-layout output-tabs" activeIndex={activeIndex} items={tabs} onChange={onChange} /> */}
                {locale === 'de' && <p className="desc-text">{t('desc')}</p>}
                <div className="d3m-tabs">
                    <Tabs className="output-tabs" tabs={tabs} activeIndex={activeIndex} onChange={onChange} />
                </div>
            </AnimatedSection>

            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
        </div>
    );
};

export default Output;
